import { motion } from "framer-motion";
import { ArrowRight, Users } from "lucide-react";

export const Network = ({ t }) => {
  return (
    <section data-testid="network-section" className="relative py-24 md:py-32 bg-pink-brand noise-overlay overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.6 }}
            className="lg:col-span-8"
          >
            <p data-testid="network-overline" className="font-mono-accent text-xs uppercase tracking-[0.3em] text-white/80 mb-4 flex items-center gap-3">
              <Users size={16} strokeWidth={1.5} />
              {t.network.overline}
            </p>
            <h2 data-testid="network-title" className="font-display font-bold text-4xl md:text-6xl text-white tracking-tight">
              {t.network.title}
            </h2>
            <p data-testid="network-text" className="mt-6 max-w-2xl text-base md:text-lg text-white/90 leading-relaxed">
              {t.network.text}
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="lg:col-span-4 lg:justify-self-end"
          >
            <a
              href="#kontakt"
              data-testid="network-cta"
              className="group inline-flex items-center gap-3 bg-[#08080a] text-white font-mono-accent text-xs uppercase tracking-[0.2em] px-8 py-4 hover:bg-white hover:text-[#08080a] transition-colors duration-200"
            >
              {t.network.cta}
              <ArrowRight size={16} className="transition-transform duration-200 group-hover:translate-x-1" />
            </a>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
